(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["designer"]) return;
  try {
    
async function sendToCart() {
  if (cartButton.classList.contains('disabled')) {
    return false;
  }
  project_id = $("#full-designer").data("project_id")
  variant_id = $("#full-designer").data("variant_id")
  old_project_id = $("#full-designer").data("old_project_id")
  thumbnail_url = $("#full-designer").data('design-image')
  warning = ""
  if ($("#warning_red").is(":visible")) {
    warning = "red";
  } else if ($("#warning_yellow").is(":visible")){
    warning = "yellow";
  }
  const approvalSelection = $('input[name="approval"]:checked').val();

  if (old_project_id) {
    getCart().then((cart) =>
{
      index = cart.items.findIndex(obj => obj.properties._project_id == old_project_id)
      if (index != -1) {
        updateItemByLine(index+1, 1, {
          '_project_id': project_id,
          '_thumbnail_url': thumbnail_url,
          '_warning': warning,
          'Design Approval': approvalSelection

        }).then(response =>{
          window.location.href = 'https://bestflag.com/cart';
        }).catch((error) => {
          console.error('Error:', error);
        });
      } else {
        addItem(variant_id, 1, {
          '_project_id': project_id,
          '_thumbnail_url': thumbnail_url,
          '_warning': warning,
          'Design Approval': approvalSelection
        }).then(response => {
          window.location.href = 'https://bestflag.com/cart';
        }).catch((error) => {
          console.error('Error:', error);
        });
      }
    })
  } else {
    addItem(variant_id, 1, {
      '_project_id': project_id,
      '_thumbnail_url': thumbnail_url,
      '_warning': warning,
      'Design Approval': approvalSelection
    }).then(response => {
      window.location.href = 'https://bestflag.com/cart';
    }).catch((error) => {
      console.error('Error:', error);
    });
  }
}

async function getCart() {
  const result = await fetch("/cart.json");
  if (result.status === 200) {
    return result.json();
  }
  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

async function addItem(variantId, quantity, properties = {}) {
  const result = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
      properties: properties
    })
  })
  return result.json();
}

async function updateItem(data) {
  const result = await fetch("/cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify(data)
  });
  return result.json();
}

function updateItemByLine(oneBasedLineIndex, newQuantity, newProperties = {}) {
  return updateItem({
    line: oneBasedLineIndex,
    quantity: newQuantity,
    properties: newProperties
  });
}

const approvalButton = document.getElementById('approval');
const cartButton = document.getElementById('add-to-cart-from-designer')

// approvalButton.addEventListener("click", approveCart, false)
cartButton.addEventListener("click", sendToCart, false)

function approveCart() {
  const v = $('input[name="approval"]:checked').val();

  if (v) {
    cartButton.classList.remove('disabled');
    cartButton.removeAttribute('disabled');
  } else {
    cartButton.classList.add('disabled');
    cartButton.setAttribute('disabled', 'disabled');
  }

const proofNote = document.getElementById('proof-note');
const approveNote = document.getElementById('approve-note');

if (proofNote)  proofNote.style.display  = (v === 'request-proof') ? 'block' : 'none';
if (approveNote) approveNote.style.display = (v === 'approve')       ? 'block' : 'none';

}



// Attach event listeners to the radio buttons
$('input[name="approval"]').on("change", approveCart);


let modal = document.querySelector("#designer-approve-modal")
// safety fallback during rollout: if id missing, pick the modal that contains our approve button
  || [...document.querySelectorAll(".modal")].find(x => x.querySelector("#add-to-cart-from-designer"));
const trigger = document.querySelector(".trigger");
const closeButton = document.querySelector(".close-button");
const backButton = document.querySelector('#designer-return')
const logoButton = document.querySelector('.site-header__logo-image')

function toggleModal() {
  if ($("#warning_red").is(":visible")) {
    swal({
      text: "Your artwork resolution is lower than recommended and will look pixelated once printed. You may keep designing and upload a higher quality version of your image to ensure the best print quality, or proceed to approval and our design team will reach out to you once they have reviewed your design.",
      icon: "warning",
      buttons: ["Keep Designing", "Proceed to Approval"],
      dangerMode: true,
      }).then((willDelete) => {
      if (willDelete) {
        modal.classList.toggle("show-modal");
        getProjectInfo()
      }
    })
  } else if ($("#warning_yellow").is(":visible")){
    swal({
      text: "Your artwork resolution is lower than recommended and may look pixelated once printed. We recommend uploading a higher quality image to ensure the best print quality.",
      icon: "warning",
      buttons: ["Keep Designing", "Proceed to Approval"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        modal.classList.toggle("show-modal");
        getProjectInfo()
      }
    })
  }else{
    modal.classList.toggle("show-modal");
    getProjectInfo()
  }
}

function windowOnClick(event) {
  if (event.target === modal) {
    closeModal();
  }
}

function confirmReturn() {
  event.preventDefault()
  swal({
    text: "Your design will not be saved unless you approve and add it to your cart.",
    icon: "warning",
    buttons: ["Keep Designing", "Return To Product"],
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      url = document.getElementById('designer-return').href
      window.location.href = url
    }
  });
}

function confirmRoot() {
  event.preventDefault()
  swal({
    text: "Your design will not be saved unless you approve and add it to your cart.",
    icon: "warning",
    buttons: ["Keep Designing", "Return To Product"],
    dangerMode: true,
  }).then((willDelete) => {
    if (willDelete) {
      url = document.getElementById('designer-return').href
      window.location.href = "https://bestflag.com/"
    }
  });
}

logoButton.addEventListener("click", confirmRoot);
backButton.addEventListener("click", confirmReturn);
trigger.addEventListener("click", toggleModal);
closeButton.addEventListener("click", closeModal);
window.addEventListener("click", windowOnClick);

function closeModal() {
  modal.classList.remove("show-modal");
}

function getProjectInfo(){
  id =  $("#full-designer").data('project_id')
  token = $("#full-designer").data('access_token')
  if(!token) {
      getGuestAuth().then(response => {
              return getProjectInfo()
          }
      )
  }
  fetch(`https://printlabs.designhuddle.com/api/projects/${id}`, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  })
      .then(res => res.json())
      .then(json => {
  const thumb = json.data.pages[0]?.thumbnail_url;
  $("#full-designer").data('design-image', thumb);
  const proofEl = document.getElementById('proofImage');
  if (proofEl && thumb) proofEl.src = thumb;
})

}

async function calculateParams() {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  return params;
}

window.addEventListener('load', (event) => {
  var project_id = projectWatch(0);
  var access_token_watcher = authWatch(0);
  var variant_watcher = variantWatch(0);
  calculateParams().then((params) => {
    if (params['variant_id'] != undefined) {
      var variant_id = params['variant_id']
    } else {
      var variant_id = params['back'].split('?variant=')[1];
        }
      variant_watcher.watch = variant_id;
      if (params['project_id']) {
          $("#full-designer").data("old_project_id", params['project_id']);
      }
      setUpInfo(params['back'], variant_id)
      configureDesignHuddle().then(
          results => {
              getGuestAuth(access_token_watcher)
              if (params['template_code']){
                  createProject(params['template_code'], project_id);
              } else if (params['project_id']){
                  $("#full-designer").data("old_project_id", params['project_id']);
                  cloneProject(params['project_id'], project_id, access_token_watcher)
              }
          }
      )
  });
})
  
function exerciseProjectId(value) {
  assignProjectId(value)
  setUpDesigner(value)
}

function setUpInfo(back, variant_id) {
  setUpBackButton(back);
  assignVariantId(variant_id);
  assignProductInfo(variant_id);
}

function assignProductInfo(variant_id) {
  var current_url = window.location.href;
  var variant_id = current_url.split("variant_id=")[1];
  jQuery.getJSON(`/variants/${variant_id}.js`, function(variant) {
    var title = variant.name.split('-')
    $("#product-info__title").text(title[0]);
    $("#product-info__subtitle").text(title[1]);
  })
}

function setUpBackButton(url) {
  document.getElementById('designer-return').setAttribute('href', url)
};

function projectWatch(j) {
  return new Proxy(JSON.parse ('{"watch":' + j + '}'), {
      set: function(target, property, value) {
          target[property] = value;
          exerciseProjectId(value);
      }
  });
}

function variantWatch(j) {
  return new Proxy(JSON.parse ('{"watch":' + j + '}'), {
      set: function(target, property, value) {
          target[property] = value;
          assignVariantId(value);
      }
  });
}

function authWatch(j) {
  return new Proxy(JSON.parse ('{"watch":' + j + '}'), {
      set: function(target, property, value) {
          target[property] = value;
          setGuestAuth(value);
      }
  });
}

function createProject(template_code, project_id) {
  DSHDEditorLib.createProject({
      template_code: template_code
  }, function(error,data){
      if(error){
          console.log(error);
      }else{
          project_id.watch = data.project_id;
      }
  })
}

async function configureDesignHuddle(){
  if ($('#full-designer').data('accessToken')){
    return await DSHDEditorLib.configure({domain: "printlabs.designhuddle.com", access_token: $('#full-designer').data('accessToken')})
  } else {
    return await DSHDEditorLib.configure({domain: "printlabs.designhuddle.com", client_id: "xzwflphl202t1b3ov29p", guest: true})
  }
}

function setGuestAuth(access_token) {
  $("#full-designer").data("access_token", access_token);
}

async function getGuestAuth(access_token_watcher) {
  access_token_watcher = access_token_watcher || authWatch(0);
  return await DSHDEditorLib.getGuestAccessToken({}, function(err, access_token){
      if (!err){
          setGuestAuth(access_token);
          if (access_token_watcher) {
              access_token_watcher.watch = access_token;
          }
      }
  })
}

function setUpDesigner(project_id) {
  var editor = null;
  DSHDEditorLib.insert("full-designer", {project_id: project_id}, function(err, e){
  if (!err) {
      editor = e;
      console.log(editor)
      document.getElementById("center").remove();
      checkDesigner(editor);
    }
  });
}

function checkDesigner(editor) {
  if (editor) {
    editor.getProjectData({simple:false}, function(err, data){
      for (var p in data.pages) {
        var page = data.pages[p];
        var dpi_multiplier = 1;
        if (page.dimensions.unit_type_id == "in") {
          dpi_multiplier = 200;
          dpi_min_multipler = 100;
        } else if (page.dimensions.unit_type_id == "mm") {
          dpi_multiplier = 200 / 25.4;
          dpi_min_multipler = 100 / 25.4;
        }
        for (var e in page.elements) {
          var element = page.elements[e];
          if (element.type == "image") {
            if ((element.width * dpi_min_multipler > element.source_width)) {
              $("#warning_red").show();
              $("#warning_yellow").hide();
              console.log('Not Good Enought Resolution Element:', element.element_name || e);
            } else if ((element.width * dpi_multiplier) > element.source_width) {
              $("#warning_red").hide();
              $("#warning_yellow").show();
              console.log('Low Resolution Element:', element.element_name || e);
            } else {
              $("#warning_red").hide();
              $("#warning_yellow").hide();
            }
          }
        }
      }
    });
    setTimeout(function() {
      checkDesigner(editor);
    }, 5000);
  } else {
      return false;
  }
}

function assignVariantId(variant_id){
  $("#full-designer").data("variant_id", variant_id);
}

function assignProjectId(project_id){
  $("#full-designer").data("project_id", project_id);
}

function cloneProject(old_project_id, project_id, access_token_watcher){
  $("#full-designer").data("old_project_id", old_project_id);
  token = $("#full-designer").data('access_token')
  if(!token) {
      getGuestAuth(access_token_watcher).then(response => {
              return cloneProject(old_project_id, project_id, access_token_watcher);
          }
      )
  }
  $("#full-designer").data("old_project_id", old_project_id);
  fetch(`https://printlabs.designhuddle.com/api/projects/${old_project_id}/clone`, {
      method: 'POST',
      headers: {
          Authorization: `Bearer ${token}`
      }
  })
      .then(res => res.json())
      .then(json => project_id.watch = json.data.project_id);
}

$(document).ready(function(){
  setTimeout(function(){
      var variant_watcher = variantWatch(0);
      calculateParams().then((params) => {
        if (params['variant_id'] != undefined) {
          var variant_id = params['variant_id']
        } else {
          var variant_id = params['back'].split('?variant=')[1];
            }
          variant_watcher.watch = variant_id;
          if (params['project_id']) {
              $("#full-designer").data("old_project_id", params['project_id']);
          }
          setUpInfo(params['back'], variant_id)
      }, 5000)
  })
})
/* ===== Mobile Warning logic (v2, safer + broader) ===== */
document.addEventListener('DOMContentLoaded', function () {
  try {
    // Broader "mobile-ish" detection: width OR UA, slightly higher breakpoint
    var mqMobile = window.matchMedia('(max-width: 820px)').matches;
    var uaMobile = /(Mobi|Android|iPhone|iPad|iPod)/i.test(navigator.userAgent);
    var isMobile = mqMobile || uaMobile;

    var modal       = document.getElementById('mobile-warning-modal');
    if (!modal) return;

    var continueBtn = document.getElementById('mobile-warning-continue');
    var returnBtn   = document.getElementById('mobile-warning-return');
    var backAnchor  = document.getElementById('designer-return');

    // Keep the Return link consistent with your header button
    if (backAnchor && returnBtn) {
      returnBtn.href = backAnchor.href;
    }

    // New session key so past dismissals don’t suppress this version
    var SESSION_KEY = 'bf_dh_mobile_warning_dismissed_v2';

    // Allow manual forcing via URL (?force_mobile_warning=1)
    var params = new URLSearchParams(location.search);
    var force  = params.get('force_mobile_warning') === '1';

    // Check dismissal with sessionStorage, fallback to localStorage if needed
    var dismissed = false;
    try {
      dismissed = sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      // Private mode or disabled? fallback:
      dismissed = (localStorage.getItem(SESSION_KEY) === '1');
    }

    if ((isMobile || force) && !dismissed) {
      // Explicitly remove @hidden for cross-browser reliability
      modal.removeAttribute('hidden');
      // If a CSS rule ever sets display:none; ensure we overwrite
      modal.style.display = 'grid';
    }

    // Continue button: hide + remember dismissal
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        modal.setAttribute('hidden', 'hidden');
        modal.style.display = 'none';
        try {
          sessionStorage.setItem(SESSION_KEY, '1');
        } catch (e) {
          localStorage.setItem(SESSION_KEY, '1');
        }
      });
    }
  } catch (err) {
    console.warn('Mobile warning setup failed:', err);
  }
});


document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var projectId = $("#full-designer").data('project_id');
    if (projectId) {
      document.getElementById('projectId').innerHTML = projectId;
    } else {
      console.log('projectId not available yet');
    }
  }, 5000);
});
  

  } catch(e) { console.error(e); }
})();
})();
